module.exports = __webpack_public_path__ + "img/g.64915329.png";